import { MenuItem } from '@mui/material';
import RoundedSelect from 'common/components/RoundedSelect';
import { containsText } from 'common/utils/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getServiceTypes } from 'redux/slices/iCalendarV4';

const SelectServiceType = ({ customMenuProps, onSubmit, fullWidth, size = 'small' }) => {
    const { t } = useTranslation();
    const allServiceTypes = useSelector(getServiceTypes);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [params] = useSearchParams();
    const serviceType = params.get('serviceType') || 'all';
    const [open, setOpen] = useState(false);

    const onTypeFilter = (text) => {
        const newTypes = allServiceTypes.filter((option) => containsText(option.name + option.externalId, text));
        setServiceTypes(newTypes);
    };

    useEffect(() => {
        if (!open) {
            setServiceTypes([...allServiceTypes]);
        }
    }, [allServiceTypes, open]);

    return (
        <RoundedSelect
            bold={true}
            value={serviceType}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            onChange={(e) => {
                onSubmit(e, 'serviceType');
            }}
            size={size}
            search={allServiceTypes.length > 10}
            searchPlaceholder={t('iCalendar.filter.searchTemplateTypes')}
            onSearchFilter={onTypeFilter}
            customMenuProps={customMenuProps}
            fullWidth={fullWidth}
        >
            <MenuItem value="all">{t('iCalendar.filter.allTemplateTypes')}</MenuItem>
            {serviceTypes?.map((type) => (
                <MenuItem key={type.id} value={type.slug}>
                    {type.name}
                </MenuItem>
            ))}
        </RoundedSelect>
    );
};

export default SelectServiceType;
